<template>
  <div>
    <div class="text-center w-100">
      <v-col cols="2">
        <v-text-field
          label="Giorno"
          v-bind:value="dateFrom"
          readonly
        ></v-text-field>
      </v-col>
      <v-row>
        <v-col cols="6">
          <v-dialog
            ref="dialog"
            v-model="modalTimeFrom"
            :return-value.sync="time"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="timeFrom"
                label="Da ore"
                v-bind:disabled="eventInfo.giornoIntero"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTimeFrom"
              v-model="time"
              full-width
              format="24hr"
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalTimeFrom = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="changeTimeFrom(time)">
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
        <v-col cols="6">
          <v-dialog
            ref="dialog"
            v-model="modalTime"
            :return-value.sync="time"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="timeTo"
                v-bind:disabled="eventInfo.giornoIntero"
                label="A ore"
                prepend-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="modalTime"
              v-model="time"
              format="24hr"
              full-width
            >
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modalTime = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="changeTimeTo(time)">
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog>
        </v-col>
      </v-row>

      <v-checkbox
        v-model="eventInfo.giornoIntero"
        label="Giornata Intera"
      ></v-checkbox>
      <!--
      <div class="d-flex justify-space-between">
        <v-btn
          class="text-none"
          style="min-width: 88px;"
          color="primary"
          depressed
          @click="$router.go(-1)" 
        >
         Indietro
        </v-btn>
  

    
        <v-btn
          class="text-none"
          style="min-width: 88px;"
          color="primary"
          depressed
          @click="$router.push({ name: 'formoperatore' })"
        >
         Avanti
        </v-btn>
      </div>-->
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["eventInfo"],
  components: { moment },
  data: () => ({
    show: false,
    dateMenuFrom: false,
    dateMenuTo: false,

    time: null,
    datemenu: false,
    modalTimeFrom: false,
    modalTime: false,
  }),
  methods: {
    changeTimeFrom(time) {
      this.timeFrom = time;
      this.modalTimeFrom = false;
    },
    changeTimeTo(time) {
      this.timeTo = time;
      this.modalTime = false;
    },
  },
  computed: {
    dateFrom: {
      get() {
        return moment(this.eventInfo.inizio).format("YYYY-MM-DD"); //this.$store.state.dateFrom
      },
      set(value) {
        this.eventInfo.inizio = new Date(value); // this.$store.commit('updateDateFrom', value)
      },
    },
    dateTo: {
      get() {
        return moment(this.eventInfo.fine).format("YYYY-MM-DD"); //this.$store.state.dateTo
      },
      set(value) {
        this.eventInfo.fine = new Date(value); //this.$store.commit('updateDateTo', value)
      },
    },

    timeFrom: {
      get() {
        return moment(String(this.eventInfo.inizio)).format("HH:mm"); //this.$store.state.dateTo
      },
      set(value) {
        let splitted = value.split(":");
        let inizio=moment(String(this.eventInfo.inizio));
        
        let date = new Date( 
         inizio.format("YYYY"),
         Number(inizio.format("MM"))-1,
         inizio.format("DD"),
          splitted[0],
          splitted[1] 
        );
        console.log(value);
        console.log(date);
        this.eventInfo.inizio = moment(date).format("YYYY-MM-DDTHH:mm:00");
      },
    },
    timeTo: {
      get() {
        return moment(String(this.eventInfo.fine)).format("HH:mm"); //this.$store.state.dateTo
      },
      set(value) {
        let splitted = value.split(":");
        let fine=moment(String(this.eventInfo.fine));
        let date = new Date( 
         fine.format("YYYY"),
         Number(fine.format("MM"))-1,
         fine.format("DD"),
          splitted[0],
          splitted[1] 
        );
        console.log(value);
        this.eventInfo.fine =  moment(date).format("YYYY-MM-DDTHH:mm:00");
      },
    },

    giornataInteraCheckbox: {
      get() {
        return this.eventInfo.GiornoIntero;
      },
      set(value) {
        console.log(value, "ME");
        this.eventInfo.GiornoIntero = value;
      },
    },
  },
};
</script>
